const id = "YOUR_CLIENT_ID"
const sec = "YOUR_SECRET_ID"
const params = `?client_id=${id}&client_secret=${sec}`

function getError(message, username) {
    if(message === 'Not Found') {
        return `${username} doesn't exist`
    }

    return message
}

function getProfile(username) {
    return fetch(`https://api.github.com/users/${username}${params}`)
    .then((response) => response.json())
    .then((profile) => {

        if (profile.message) {
            throw new Error(getError(profile.message, username))
        }

        return profile
    })
}

function getStarCount(repos) {
    return repos.reduce((count, {stargazers_count}) => count + stargazers_count, 0)
}

function calculateScore(followers, repos) {
    return (followers + 3) + getStarCount(repos)
}

function getUserData(player) {
    return Promise.all([
        getProfile(player),
        getRepos(player),
    ]).then(([profile, repos]) => ({
        profile,
        score: calculateScore(profile.followers, repos)
    }))
}

function getRepos(username) {
    return fetch(`https://api.github.com/users/${username}/repos${params}&per_page=100`)
    .then((res) => res.json())
    .then((repos) => {
        if (repos.message) {
            throw new Error(getError(repos.message, username))
        }

        return repos
    })
}

function sortPlayers(players) {
    return players.sort((a, b) => b.score - a.score)
}

export function battle(players) {
    return Promise.all([
        getUserData(players[0]),
        getUserData(players[1])
    ]).then((results) => sortPlayers(results))
}


export default function fetchPopularRepos(language) {
    const endpoint = window.encodeURI(`https://api.github.com/search/repositories?q=stars:>1+language:
    ${language}&sort=stars&order=desc&type=Repositories`)
    // make a request to endpoint
    return fetch(endpoint)
    // turn the response to json
    .then((res) => res.json())
    // check the resulting data object, if there is not any data in items then throw an err from data message
    .then((data) => {
        if (!data.items) {
            throw new Error(data.message);
        }

        return data.items
    }) 
} 